import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { IconsModule } from '@shared/icons/icons.module';

import { CbpLogMessageComponent, CbpLogMessageListComponent, CbpMessagesTableComponent } from './components';
import { IsfCBPMessagesService } from '@shared/cbp-messages/services';

@NgModule({
  declarations: [CbpMessagesTableComponent, CbpLogMessageListComponent, CbpLogMessageComponent],
  imports: [CommonModule, PipesSharedModule, TranslateModule, IconsModule],
  exports: [CbpMessagesTableComponent, CbpLogMessageListComponent],
  providers: [IsfCBPMessagesService],
})
export class CbpMessagesModule {}
